export const habaMyAccountNavigation = {
  myAccountNavigation: {
    benefits: {
      label: 'Vorteile',
      presentDesk: 'Geschenketisch'
    },
    customerData: {
      changeData: 'Kundendaten ändern',
      label: 'Kundendaten'
    },
    general: {
      article: 'Meine Artikel',
      history: 'Meine Bestellungen',
      overview: 'Meine Übersicht',
      premium: 'Premiumversand',
      return: 'Rücksendung',
      wishlist: 'Meine Merkliste'
    },
    navigation: {
      heading: 'Übersicht',
      clientData: 'Meine Kundendaten',
      personalData: 'Persönliche Daten',
      companyData: 'Auftraggeber',
      loginData: 'Login Daten',
      billingAddress: 'Rechnungsadresse',
      deliveryAddress: 'Meine Lieferadressen',
      orderHistory : 'Meine Bestellübersicht'
    }
  }
};
